import { arrayAny } from '../../utils/arrayUtils';
import _ from 'lodash';

export const getCurrentRentAmount = tenant => {

    const activePeriods = [];

    for (const tenancy of tenant.tenancies) {

        for (const period of tenancy.rentalPeriods) {

            if (period.period.end === null) {
                activePeriods.push(period);
            }
        }
    }

    if (arrayAny(activePeriods)) {
        return parseFloat(_.first( _.orderBy(activePeriods, rp => new Date(rp.period.start, "desc"))).rentalValue).toFixed(2);
    }
    return "Not Set";
};